import { SiteData } from "../Data/SiteData";
import SiteStyleCollectionMenu from "./SiteStyleCollectionMenu";
import { wBComponentTypeNames } from "vagaro-website-rendering/src/components/Definitions/WBComponentTypeNames";

export default function AnnouncementBarMenu({saveFunc,siteData}:{saveFunc:Function,siteData:SiteData}){

    siteData.siteStyling.announcementBar.typename = wBComponentTypeNames.announcementBar;

      return <SiteStyleCollectionMenu 
        title="Announcement Bar"
        saveFunc={saveFunc}
        siteData={siteData}
        collectionList={[siteData.siteStyling.announcementBar]}
        labelList={["Announcement Bar"]}
        componentType={wBComponentTypeNames.announcementBar}
        includeAll={true}
        saveOnUpdate={true}
  
      />
  
  }